import { createApp } from 'vue';
import App from './App.vue';
import router from './router'
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css';
import './assets/styles/global.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { vPermission } from './utils/permission';
import { ElMessage } from 'element-plus';
import APP_CONFIG from './utils/config';
import request from './utils/request';

const app = createApp(App);

app.use(ElementPlus, {
    locale: zhCn,
  });

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.directive('permission', vPermission);

app.use(router);

request.get('/index/index/info').then(res => {
  const data = res.data || res;
  if (data.company_name) {
    APP_CONFIG.COMPANY_NAME = data.company_name;
    localStorage.setItem('COMPANY_NAME', data.company_name);
  }
  if (data.version) {
    APP_CONFIG.VERSION = data.version;
    localStorage.setItem('VERSION', data.version);
  }
}).catch(err => {
  ElMessage.warning('获取系统信息失败');
  console.warn('获取系统信息失败，使用默认配置:', err);
});

app.mount('#app');